import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Info } from 'lucide-react';

import Button from '../../common/Button';
import Loading from '../../common/Loading';
import { useGetScenarioListDisplay } from '../../hooks/tanstack/useScenariosHook';
import {
  useGetDistinguishModel,
  useGetRouteParams,
} from '../../hooks/tanstack/useUtilsHook';
import ScenarioGroupInputTable from '../scenario/ScenarioInputTable';

const ModelScenarioOverview = () => {
  const { orgId, projectId, modelId } = useGetRouteParams();

  const [searchParams, setSearchParams] = useSearchParams();

  const { model } = useGetDistinguishModel();

  const { data: listDisplay, isLoading: isLoadingListDisplay } =
    useGetScenarioListDisplay(
      {
        orgId,
        projectId,
        modelId,
      },
      {
        enabled: !!orgId && !!projectId && !!modelId,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      }
    );

  const handleNavigate = () => {
    searchParams.set('tab', 'configuration');
    setSearchParams(searchParams);
  };

  return (
    <div className="flex flex-col justify-between gap-4 pb-3">
      <h2 className="text-3xl font-bold">Scenario & Expense</h2>
      {!model?.is_base && (
        <div className="flex gap-2 items-center">
          <div>
            <Info size={20} color="#666666" />
          </div>
          <p className=" text-[#666] flex items-center font-semibold">
            If you can't find the expense your're looking for, please go the
            &nbsp;
            <Button variant="link_blue" onClick={handleNavigate}>
              Configuration
            </Button>
            &nbsp; page to set your expenses.
          </p>
        </div>
      )}
      <div className="space-y-6">
        {isLoadingListDisplay && <Loading />}
        {listDisplay?.groups.map((group) => (
          <ScenarioGroupInputTable
            key={group.name}
            groupName={group.name}
            isLoading={isLoadingListDisplay}
            dataTableSchemas={group.data_table_schemas}
          />
        ))}
      </div>
    </div>
  );
};

export default ModelScenarioOverview;
